export default class MobileMenu {
    constructor() {
        if (!$('.mobile-menu').length || !$('.mobile-header').length) {
            return false;
        }

        this.openTrigger = $('.mobile-header .hamburger-click').children();
        this.closeTrigger = $('.mobile-menu .close');

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);

        this.openTrigger.bind('click', this.onOpen);
        this.closeTrigger.bind('click', this.onClose);

        this.open = false;
    }

    onOpen() {
        if (this.open) {
            return false;
        }

        this.open = true;
        $('body').addClass('no-scroll');
        $('.mobile-menu').addClass('open');
    }

    onClose() {
        if (!this.open) {
            return false;
        }

        this.open = false;
        $('body').removeClass('no-scroll');
        $('.mobile-menu').removeClass('open');
    }
}